import React from "react";

import { Box, Stack, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

import { HelpBox } from "@/components/atoms";
import { toRounded } from "@/utils";

interface NamedStatBoxProps {
  title: string;
  name: string;
  value: number;
  valueFormatter?: (value: number) => number | string;
  icon?: React.ReactNode;
  description?: string;
}

const NamedStatBox: React.FC<NamedStatBoxProps> = ({
  title,
  name,
  value,
  valueFormatter = toRounded,
  icon,
  description,
}) => {
  const theme = useTheme();

  return (
    <Stack
      spacing={2}
      border={1}
      borderRadius={1}
      borderColor={theme.palette.divider}
      p={2}
      minWidth={"144px"}
    >
      <Typography>{title}</Typography>
      <HelpBox title={description} placement="bottom">
        <Stack spacing={1} direction="row" alignItems="center">
          {icon}
          <Stack>
            <Typography variant="caption">{name}</Typography>
            <Box display="flex" justifyContent="flex-start">
              <Typography variant="h5">{valueFormatter(value)}</Typography>
            </Box>
          </Stack>
        </Stack>
      </HelpBox>
    </Stack>
  );
};

export default NamedStatBox;
